import { render, staticRenderFns } from "./PagoExitoso.vue?vue&type=template&id=906edf86&"
import script from "./PagoExitoso.vue?vue&type=script&lang=js&"
export * from "./PagoExitoso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports